import {type ISystemGroup, GroupType} from '../schema/group/groupSchema';
import {canManageSystemGroups} from './canManageSystemGroups';

/** can group be deleted by current user */
export const canDeleteSystemGroup = (group?: ISystemGroup) =>
	!!group && group.type === GroupType.USER_CREATED && canManageSystemGroups();
